import { render } from "./UploadIcon.vue?vue&type=template&id=ce9098ce&scoped=true"
import script from "./UploadIcon.vue?vue&type=script&lang=js"
export * from "./UploadIcon.vue?vue&type=script&lang=js"

import "./UploadIcon.vue?vue&type=style&index=0&id=ce9098ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9098ce"]])

export default __exports__